var render = function render(){var _vm=this,_c=_vm._self._c;return _c('marketing-automation-form-panel-section',{attrs:{"title":"Definir campanhas"}},[_c('CampaignTreeFilter',{attrs:{"id":"campaignTree","value":_vm.formattedCampaginsArray,"campaigns":_vm.campaigns},on:{"input":_vm.emitChangeTest}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }